export default __webpack_public_path__ + "static/icon-23-6-41a47b122ebf8312c4b480a12c8b2275.png";